<template>
    <footer class="footer" />
</template>

<script>
export default {};
</script>

<style lang="scss">
.footer {
    background: var(--v-footer-base);
    border-top: 2px solid var(--brand-border);
    padding: 1rem 5%;
}
</style>
